import useMediaQuery from "@mui/material/useMediaQuery";

/** How long a folding header slides (BRK-S267; Nav, 2026-09-28: "There's no
 *  animation/transition while folding the headers"). */
export const FOLD_MS = 200;

/** The fold's duration for MUI's transitions: none for a broker who asked the
 *  system to reduce motion. */
export function useFoldTimeout(): number {
  const reduce = useMediaQuery("(prefers-reduced-motion: reduce)", {
    noSsr: true,
  });
  return reduce ? 0 : FOLD_MS;
}
